import { render } from "./TitleBar.vue?vue&type=template&id=3711a4d0&scoped=true&ts=true"
import script from "./TitleBar.vue?vue&type=script&lang=ts"
export * from "./TitleBar.vue?vue&type=script&lang=ts"

import "./TitleBar.vue?vue&type=style&index=0&id=3711a4d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3711a4d0"]])

export default __exports__